import React from 'react';

import { useSafeImageSrc } from './SafeImage';

const ContainedImage = props => {
    const {src, altSrc, className = '', size, onClick, children} = props,
        checkedSrc = useSafeImageSrc(src, altSrc),
        style = {
            ...props.style,
            backgroundImage: checkedSrc ? `url('${checkedSrc}')` : null,
        };

    if (size) {
        style.width = size;
        style.height = size;
    }

    return (
        <div className={['img', className].join(' ')} style={style} onClick={onClick}>
            {children}
        </div>
    );
};

export default ContainedImage;
